/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Deload_ExplainInputs */

const en_us2_plan_deload_explain = /** @type {(inputs: Plan_Deload_ExplainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Why lighter?`)
};

const pt_br2_plan_deload_explain = /** @type {(inputs: Plan_Deload_ExplainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por que mais leve?`)
};

const es_419_plan_deload_explain = /** @type {(inputs: Plan_Deload_ExplainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Por qué más liviano?`)
};

const pt_pt2_plan_deload_explain = /** @type {(inputs: Plan_Deload_ExplainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Porquê mais leve?`)
};

const fr_fr2_plan_deload_explain = /** @type {(inputs: Plan_Deload_ExplainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pourquoi plus léger ?`)
};

const de_de2_plan_deload_explain = /** @type {(inputs: Plan_Deload_ExplainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Warum leichter?`)
};

const it_it2_plan_deload_explain = /** @type {(inputs: Plan_Deload_ExplainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perché più leggero?`)
};

/**
* | output |
* | --- |
* | "Why lighter?" |
*
* @param {Plan_Deload_ExplainInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_deload_explain = /** @type {((inputs?: Plan_Deload_ExplainInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Deload_ExplainInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_deload_explain(inputs)
	if (locale === "es-419") return es_419_plan_deload_explain(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_deload_explain(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_deload_explain(inputs)
	if (locale === "de-DE") return de_de2_plan_deload_explain(inputs)
	if (locale === "it-IT") return it_it2_plan_deload_explain(inputs)
	return en_us2_plan_deload_explain(inputs)
});
export { plan_deload_explain as "plan.deload.explain" }